function setNullable(key: string, value: any) {
    if (value === null || value === undefined) {
        sessionStorage.removeItem(key);
    }

    sessionStorage.setItem(key, value);
}

enum StorageKeys {
    ImpersonationResidentialUnitId = 'impersonationResidentialUnitId',
}

class BrowserSessionStorage {
    get impersonationResidentialUnitId(): number | null {
        return +sessionStorage.getItem(StorageKeys.ImpersonationResidentialUnitId)! || null;
    }

    set impersonationResidentialUnitId(residentialUnitId: number | null) {
        setNullable(StorageKeys.ImpersonationResidentialUnitId, residentialUnitId);
    }
}

export default new BrowserSessionStorage();